__webpack_require__.hmrF = () => ("critical." + __webpack_require__.h() + ".hot-update.json");